export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="133" height="27" viewBox="0 0 133 27" fill="none">
            <path d="M42.1973 16.5161H44.8302L46.211 11.366H58.1362L58.8619 8.66504H44.3011L42.1973 16.5161Z" fill="white" />
            <path d="M44.9585 6.21566H59.5167L60.2398 3.51465H45.6816L44.9585 6.21566Z" fill="white" />
            <path
                d="M71.2056 13.8981H62.0569L64.8285 3.5249H62.1225L59.3131 14.0064C58.9402 15.3998 59.7667 16.526 61.1575 16.526H73.1986L76.6832 3.5249H73.9772L71.2056 13.8981Z"
                fill="white"
            />
            <path
                d="M112.348 3.51465H103.822C102.154 3.51465 100.438 4.86767 99.9894 6.53816L98.1275 13.4948C97.679 15.1627 98.6692 16.5183 100.34 16.5183H108.866C110.534 16.5183 112.25 15.1653 112.698 13.4948L114.56 6.53816C115.009 4.86767 114.019 3.51465 112.348 3.51465ZM110.118 13.3033C110.034 13.5903 109.777 13.7925 109.478 13.8072H101.176C101.051 13.8136 100.93 13.7562 100.856 13.6546C100.782 13.5531 100.764 13.421 100.808 13.3033L102.572 6.72713C102.658 6.44098 102.914 6.23937 103.212 6.22322H111.527C111.652 6.21684 111.773 6.27419 111.847 6.37577C111.921 6.47734 111.939 6.60945 111.895 6.72713L110.118 13.3033Z"
                fill="white"
            />
            <path d="M92.1685 16.5158H94.8015L98.286 3.51465H95.6506L92.1685 16.5158Z" fill="white" />
            <path
                d="M79.8275 8.6647L80.4826 6.21566H92.4154L93.1386 3.51465H81.0974C79.7066 3.51465 78.2755 4.64343 77.9026 6.03425L76.4739 11.3783H88.4068L87.7491 13.8274H75.8163L75.0957 16.5259H87.1343C88.5277 16.5259 89.9563 15.3996 90.3292 14.0063L91.7578 8.67479L79.8275 8.6647Z"
                fill="white"
            />
            <path
                d="M129.738 3.51465L127.277 12.7061L120.653 3.51465H120.59H117.883L114.401 16.5158H117.107L119.569 7.32428L126.193 16.5158H127.098H128.962L132.444 3.51465H129.738Z"
                fill="white"
            />
            <path d="M33.6709 11.3783H40.945L41.6681 8.6748H34.3965L33.6709 11.3783Z" fill="white" />
            <path d="M18.3848 0H11.0527L17.4575 8.66741L22.1339 5.07951L18.3848 0Z" fill="white" />
            <path d="M25.8628 20.0334H33.1974L27.3191 12.0815L22.2598 15.158L25.8628 20.0334Z" fill="white" />
            <path d="M39.9144 0H30.7002L14.7663 12.2226H18.256L0.646484 27L30.8111 8.67749H27.2837L39.9144 0Z" fill="url(#paint0_linear_540_1506)" />
            <defs>
                <linearGradient id="paint0_linear_540_1506" x1="37.7425" y1="-1.72387e-07" x2="0.692458" y2="26.9558" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
